export function initContactForm() {
  const form = document.querySelector("[data-contact-form]");

  if (!form || typeof wp_vars === "undefined") {
    return;
  }

  const status = form.querySelector("[data-contact-status]");
  const submit = form.querySelector('button[type="submit"]');

  const showStatus = (message, state) => {
    if (!status) {
      return;
    }
    status.textContent = message;
    status.dataset.state = state;
    status.hidden = false;
  };

  form.addEventListener("submit", async (event) => {
    event.preventDefault();

    if (!form.reportValidity()) {
      return;
    }

    const data = new FormData(form);
    data.append("action", "pckia_contact_form");
    data.append("nonce", wp_vars.contact_nonce);

    submit.disabled = true;
    showStatus("Wysyłanie wiadomości…", "pending");

    try {
      const response = await fetch(wp_vars.ajax_url, {
        method: "POST",
        body: data,
      });
      const result = await response.json();

      if (result.success) {
        showStatus(result.data.message, "success");
        form.reset();
      } else {
        showStatus(result.data.message, "error");
      }
    } catch (error) {
      showStatus("Nie udało się wysłać wiadomości. Sprawdź połączenie i spróbuj ponownie.", "error");
    } finally {
      submit.disabled = false;
    }
  });
}
